/**
 * Class responsible for HTML templating
 * Constructs all GUI elements/modals used by SmartVideo
 */
namespace SmartVideo {
  export class MakeModal implements IMakeModal {
    currentModal: HTMLElement;
    params: any[];
    chromeStoreWindow: Window;
    installComponent: string;
    InstallersPath: string;
    CssPath: string;
    ImagePath: string;
    CustomerLogo: string;
    chromeExtensionUrl: string;
    VidyoWebRTCScreenShareChromeExtensionUrl: string;
    VidyoClientForWebChromeExtensionUrl: string;
    AndroidInstallLink: string;
    IOSInstallLink: string;
    StyleSheet: string;
    UseWebRTC: boolean;
    isWebRTCCapable: boolean;
    isWebRTCAvailable: boolean;
    config: ISmartVideoConfig;
    browser: string;
    vidyoDetection: IVidyoDetection;
    MobileClient: string;

    constructor() {
      this.installComponent = window.localStorage.getItem('installComponent');
      if (this.installComponent === null) {
        console.log(
          'MakeModal: No installComponent in window.localStorage. Appears all installations are complete.'
        );
      } else {
        console.log(
          'MakeModal: installComponent found in window.localStorage: ' +
            this.installComponent
        );
      }

      this.config = null;
      // Set default values, to be overriden by config values if set
      this.UseWebRTC = false;
      this.CssPath = './css/';
      this.InstallersPath = './installers/';
      this.ImagePath = './images/';
      this.CustomerLogo = null;
      this.MobileClient = 'VidyoConnect';
      this.AndroidInstallLink =
        'https://play.app.goo.gl/?link=https://play.google.com/store/apps/details?id=com.vidyo.neomobile';
      this.IOSInstallLink =
        'itms-apps://itunes.apple.com/us/app/vidyoconnect/id1103823278?mt=8';
      this.StyleSheet = 'SmartVideo.css';
    }

    // Object extend
    extend(objectToExtend: any, jsonObjects: Array<Object>) {
      objectToExtend = objectToExtend || {};
      for (let i = 0; i < jsonObjects.length; i++) {
        if (!jsonObjects[i]) {
          continue;
        }
        for (const key in jsonObjects[i]) {
          if (jsonObjects[i].hasOwnProperty(key)) {
            objectToExtend[key] = jsonObjects[i][key];
          }
        }
      }
      return objectToExtend;
    }

    // init(config: ISmartVideoConfig, browser, isWebRTCCapable: boolean, isWebRTCAvailable: boolean) {
    init(config: ISmartVideoConfig, vidyoDetection: IVidyoDetection) {
      this.vidyoDetection = vidyoDetection;
      this.isWebRTCCapable = vidyoDetection.isWebRTCCapable;
      this.browser = vidyoDetection.browserReport.browser.name;
      const that = this;

      this.config = config;
      this.extend(this, [this.config]);
      this.continueInit();
    }

    continueInit() {
      if (this.vidyoDetection.isInitialized) {
        this.UseWebRTC = this.vidyoDetection.isWebRTCAvailable;
      } else {
        setTimeout(() => {
          this.continueInit();
        }, 500);
      }
      console.log('Initializing MakeModal');
      if (this.UseWebRTC) {
        if (this.VidyoWebRTCScreenShareChromeExtensionUrl) {
          this.chromeExtensionUrl = this.VidyoWebRTCScreenShareChromeExtensionUrl;
        }
      } else {
        if (this.VidyoClientForWebChromeExtensionUrl) {
          this.chromeExtensionUrl = this.VidyoClientForWebChromeExtensionUrl;
        }
      }
      /* if (this.MobileClient === 'VidyoConnect') {
        this.AndroidInstallLink =
          'https://play.google.com/store/apps/details?id=com.vidyo.neomobile';
        this.IOSInstallLink =
          'itms-apps://itunes.apple.com/us/app/vidyoconnect/id1103823278?mt=8';
      } */
      this.loadCss();
    }

    loadCss() {
      const styleSheets = document.styleSheets;
      let isLinkedSmartVideoStyleSheet = false;
      const SmartVideoStyleSheetLowerCase = this.StyleSheet.toLowerCase();
      for (let index = 0; index < styleSheets.length; index++) {
        const element = styleSheets[index];
        if (element.href) {
          const hRef = element.href
            .toLowerCase()
            .indexOf(SmartVideoStyleSheetLowerCase);
          if (hRef !== -1) {
            isLinkedSmartVideoStyleSheet = true;
          }
        }
      }
      // If not loaded and not disabled, load the smartVideoStyleSheet
      if (!isLinkedSmartVideoStyleSheet && this.StyleSheet !== 'none') {
        const head = document.getElementsByTagName('head')[0];
        const link = document.createElement('link');
        link.id = 'smartVideoCss';
        link.rel = 'stylesheet';
        link.type = 'text/css';
        link.href = this.CssPath + this.StyleSheet;
        link.media = 'all';
        head.appendChild(link);
      }
    }

    isFunction(possibleFunction) {
      return typeof possibleFunction === typeof Function;
    }

    doCallback(possiblecallback: Function) {
      if (this.isFunction(possiblecallback)) {
        possiblecallback();
      }
    }

    successFunction() {}

    errorFunction() {
      this.openChromeWebStore();
    }

    openChromeWebStore() {
      this.chromeStoreWindow = window.open(
        this.chromeExtensionUrl,
        'chromeStoreWindow',
        'status=1,width=1000, height=300'
      );
    }

    htmlModal(config: any, callback?: Function) {
      const conf = config || {};
      let modalPop: HTMLElement;
      let existingModals: NodeListOf<Element>;

      // remove adapt-modals
      existingModals = document.getElementsByTagName('adapt-modal');
      if (existingModals && existingModals.length > 0) {
        for (let i = 0; i < existingModals.length; i++) {
          document.body.removeChild(existingModals[i]);
        }
      }

      // create modal
      if (conf.fullmodal === true) {
        modalPop = document.createElement('adapt-fullmodal');
      } else {
        modalPop = document.createElement('adapt-modal');
        modalPop.innerHTML = `
            <div class="modal">
                <div class="modal-dialog">
                    <div class="modal-content">
                        <div class="modal-header">
                            <button type="button" class="close" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                            </button>
                            <h4 class="modal-title ${conf.titleclass}"></h4>
                        </div>
                        <div class="modal-body"></div>
                        <div class="modal-footer">
                        </div>
                    </div><!-- /.modal-content -->
                </div><!-- /.modal-dialog -->
            </div><!-- /.modal -->`;
      }

      // disable close button if modal shouldn't have one
      if (!conf.hasCloseButton) {
        const closeButton = <HTMLElement>(
          modalPop.getElementsByClassName('close')[0]
        );
        if (closeButton && closeButton !== null) {
          closeButton.style.display = 'none';
        }
      }
      // use Element or innerHTML
      if (conf.fullmodal) {
        modalPop.appendChild(conf.bodyElement);
      } else {
        if (conf.bodyElement) {
          modalPop
            .getElementsByClassName('modal-body')[0]
            .appendChild(conf.bodyElement);
        } else {
          modalPop.getElementsByClassName('modal-body')[0].innerHTML =
            conf.innerHtml || '';
        }
      }

      // populate OK/Cancel/etc buttons, if any
      if (conf.footerButtons && conf.footerButtons.length > 0) {
        for (let j = 0; j < conf.footerButtons.length; j++) {
          modalPop
            .getElementsByClassName('modal-footer')[0]
            .appendChild(conf.footerButtons[j]);
        }
      }

      this.currentModal = modalPop;

      if (conf.hasCloseButton === true) {
        const modalClose = modalPop.getElementsByClassName('close')[0];
        modalClose.addEventListener(
          'click',
          () => {
            this.close();
          },
          false
        );
      }
    }

    welcomeModal(
      workgroups: Object,
      isVidyoInstalled: boolean,
      callback: Function
    ) {
      const welcomeDiv = document.createElement('div');
      welcomeDiv.className = 'welcome-body';
      const select = document.createElement('select');

      for (const workgrp in workgroups) {
        if (workgroups.hasOwnProperty(workgrp)) {
          const option = document.createElement('option');
          option.textContent = workgrp;
          option.value = workgroups[workgrp];
          select.appendChild(option);
        }
      }
      welcomeDiv.appendChild(select);

      const customerNameDiv = document.createElement('div');
      customerNameDiv.className = 'yournamelabel';

      const customerNameInput = document.createElement('input');
      customerNameInput.type = 'text';
      customerNameInput.className = 'customerName';

      const startButton = document.createElement('button');
      startButton.className = 'btn btn-primary welcomestart-button';
      startButton.addEventListener(
        'click',
        () => {
          callback(select.value, customerNameInput.value);
          console.log(
            `Workgroup Selected: ${select.value}, Customer Name: ${customerNameInput.value}`
          );
        },
        false
      );

      startButton.disabled = true;

      const cancelButton = document.createElement('button');
      cancelButton.className = 'btn btn-danger cancelButton';
      cancelButton.addEventListener(
        'click',
        () => {
          this.close();
        },
        false
      );

      // Add listener to customerNameInput, now that start button is created
      // Don't enable start unless they've entered a name
      customerNameInput.addEventListener('keyup', () => {
        if (customerNameInput.value.length !== 0) {
          startButton.disabled = false;
        } else {
          startButton.disabled = true;
        }
      });

      welcomeDiv.appendChild(customerNameDiv);
      welcomeDiv.appendChild(customerNameInput);

      const footerButtons = [startButton, cancelButton];

      const welcomeConfig = {
        titleclass: 'welcome-tital',
        bodyElement: welcomeDiv,
        hasCloseButton: false,
        footerButtons: footerButtons,
      };

      this.htmlModal(welcomeConfig);
      this.show();
    }

    chromeInstallExtensionModal(
      chromeExtensionUrl: string,
      callback: Function
    ) {
      const that = this;
      // Check to see if the chrome webstore <link> is in the web page. If not, create it.
      const links = document.links;
      let isLinkedChromeStoreExtension = false;
      const chromeStoreLinkLowerCase = this.chromeExtensionUrl.toLowerCase();
      for (let index = 0; index < links.length; index++) {
        const element = links[index];
        const hRef = element.href
          .toLowerCase()
          .indexOf(chromeStoreLinkLowerCase);
        if (hRef !== -1) {
          isLinkedChromeStoreExtension = true;
        }
      }
      if (!isLinkedChromeStoreExtension) {
        const head = document.getElementsByTagName('head')[0];
        const link = document.createElement('link');
        link.id = 'smartVideoChromeStoreExtension';
        link.rel = 'chrome-webstore-item';
        link.href = this.chromeExtensionUrl;
        head.appendChild(link);
      }
      const cancelButton = document.createElement('button');
      cancelButton.className = 'btn btn-danger cancelButton';
      cancelButton.addEventListener(
        'click',
        () => {
          window.localStorage.clear();
          this.close();
        },
        false
      );

      const footerButtons = [cancelButton];
      let installButtonClass;
      if (!this.UseWebRTC) {
        installButtonClass = 'chromeinstallvidyowebextension-button';
      } else {
        installButtonClass = 'chromeinstallvidyowebrtcextension-button';
      }
      let chromeInstallExtensionConfig;
      if (this.browser.toLowerCase() === 'chrome') {
        chromeInstallExtensionConfig = {
          titleclass: 'chromeinstallextension-tital',
          installButtonType: 'button',
          isChromeExtensionInstall: true,
          installButtonText: 'installButtonText',
          installButtonClass: installButtonClass,
          footerButtons: footerButtons,
          installButtonOnClick() {
            // webstore.install deprecated
            /* chrome.webstore.install(
                            chromeExtensionUrl,
                            that.successFunction.bind(that),
                            that.errorFunction.bind(that)
                        ); */
            window.open(that.chromeExtensionUrl);
          },
        };
      } else if (this.browser.toLowerCase() === 'opera') {
        chromeInstallExtensionConfig = {
          titleclass: 'chromeinstallextension-tital',
          installButtonType: 'button',
          isChromeExtensionInstall: true,
          installButtonText: 'installButtonText',
          installButtonClass: installButtonClass,
          footerButtons: footerButtons,
          installButtonOnClick() {
            /* that.openChromeWebStore(); */
            window.open(that.chromeExtensionUrl);
          },
        };
      }

      this.installModal(chromeInstallExtensionConfig);
    }

    chromeInstallNativeMessagingHostModal(
      chromeNMSVersion: string,
      os: string,
      callback: Function
    ) {
      let configTitle: string;
      let downloadLink = '';
      let configTitleClass: string;
      /*
            Replace the underscore at the end of chromeNMSVersion,
            because for some reason Vidyo uses x.x.x.xxxx for file name, but x.x.x_xxxx for connecting to NMS host
            */
      const chromeNMSFileNameVersion = chromeNMSVersion.replace('_', '.');
      if (os === 'Windows') {
        downloadLink =
          this.InstallersPath +
          'VidyoClientForWeb-win32-' +
          chromeNMSFileNameVersion +
          '.msi';
      } else if (os === 'OS X') {
        downloadLink =
          this.InstallersPath +
          'VidyoClientForWeb-macosx-x64-' +
          chromeNMSFileNameVersion +
          '.pkg';
      }

      if (this.installComponent === 'Chrome Extension') {
        configTitle =
          'Next, we need to also install the VidyoWeb plugin for Chrome.';
        configTitleClass = 'chromeNMS-extension-was-installed-title';
      } else {
        configTitle =
          'Looks like we need to install some software for your web browser to connect your video call';
        configTitleClass = 'chromeNMS-extension-was-present-title';
      }

      const cancelButton = document.createElement('button');
      cancelButton.className = 'btn btn-danger cancelButton';
      cancelButton.addEventListener(
        'click',
        () => {
          const chromeStoreWindowName = window.localStorage.getItem(
            'chromeStoreWindow'
          );
          const chromeStoreWindow = window.open('', chromeStoreWindowName);
          window.localStorage.clear();
          this.close();
          if (chromeStoreWindow) {
            chromeStoreWindow.close();
          }
        },
        false
      );

      const footerButtons = [cancelButton];

      const chromeInstallNmsConfig = {
        titleclass: configTitleClass,
        installButtonClass: 'chromeinstallNMS-button',
        installButtonType: 'a',
        installButtonLink: downloadLink,
        footerButtons: footerButtons,
      };
      this.installModal(chromeInstallNmsConfig);
    }

    installNpApiPluginModal(
      mimePluginVersion: string,
      os: string,
      callback: Function
    ) {
      let downloadLink = '';

      if (os === 'Windows') {
        downloadLink =
          this.InstallersPath + 'VidyoWeb-win32-' + mimePluginVersion + '.msi';
      } else if (os === 'OS X') {
        downloadLink =
          this.InstallersPath +
          'VidyoWeb-macosx-x64-' +
          mimePluginVersion +
          '.pkg';
      }

      const cancelButton = document.createElement('button');
      cancelButton.className = 'btn btn-danger cancelButton';
      cancelButton.addEventListener(
        'click',
        () => {
          window.localStorage.clear();
          this.close();
        },
        false
      );

      const footerButtons = [cancelButton];

      const pluginConfig = {
        titleclass: 'npapiinstall-title',
        installButtonClass: 'npapiinstall-button',
        installButtonType: 'a',
        installButtonLink: downloadLink,
        footerButtons: footerButtons,
      };

      this.installModal(pluginConfig);
    }

    installNeoModal(cpuClass: string, callback: Function) {
      let downloadLink: string;
      const ol = document.createElement('ol');
      let innerHtml = '';

      if (cpuClass === 'Win32' || cpuClass === 'x86') {
        downloadLink = this.InstallersPath + 'VidyoNeoInstaller-win32.exe';
      } else if (cpuClass === 'Win64' || cpuClass === 'x64') {
        downloadLink = this.InstallersPath + 'VidyoNeoInstaller-win64.exe';
      } else {
        this.noOsSupportedModal(null);
        return;
      }

      const okButton = document.createElement('button');
      okButton.className = 'btn btn-primary okButton';
      okButton.addEventListener(
        'click',
        () => {
          window.localStorage.setItem('useNeoVidyo', 'true');
          this.doCallback(callback);
        },
        false
      );
      okButton.disabled = true;

      const cancelButton = document.createElement('button');
      cancelButton.className = 'btn btn-danger cancelButton';
      cancelButton.addEventListener(
        'click',
        () => {
          this.close();
        },
        false
      );

      const footerButtons = [okButton, cancelButton];

      const installButtonListener = () => {
        this.elementEnableDisable(okButton);
      };

      for (let i = 0; i < 3; i++) {
        innerHtml =
          innerHtml + `<li class="neoinstall-instructions-li${i + 1}"></li>`;
      }

      ol.innerHTML = innerHtml;

      const neoConfig = {
        titleclass: 'neoinstall-title',
        hasCloseButton: false,
        installButtonClass: 'neoinstall-button',
        installButtonType: 'a',
        installButtonLink: downloadLink,
        installButtonListener: installButtonListener,
        innerHtml: ol.outerHTML,
        footerButtons: footerButtons,
      };

      this.installModal(neoConfig);
    }

    noOsSupportedModal(callback?: Function) {
      const noOsDiv =
        "Unfortunately, it appears we can't provide video at this time for your browser and operating system.";

      const cancelButton = document.createElement('button');
      cancelButton.className = 'btn btn-danger cancelButton';
      cancelButton.addEventListener(
        'click',
        () => {
          this.close();
        },
        false
      );

      const footerButtons = [cancelButton];

      const pluginConfig = {
        titleclass: 'noOSSupported-title',
        innerHtml: noOsDiv,
        hasCloseButton: false,
        footerButtons: footerButtons,
      };

      this.htmlModal(pluginConfig);
      this.show();
    }

    noConferencingAvailable(callback?: Function) {
      const noConfAvailableDiv = document.createElement('div');
      noConfAvailableDiv.id = 'noConfAvailableDiv';

      const cancelButton = document.createElement('button');
      cancelButton.className = 'btn btn-danger cancelButton';
      cancelButton.addEventListener(
        'click',
        () => {
          this.close();
        },
        false
      );

      const footerButtons = [cancelButton];

      const pluginConfig = {
        titleclass: 'noConfAvailableDiv-title',
        bodyElement: noConfAvailableDiv,
        hasCloseButton: false,
        footerButtons: footerButtons,
      };

      this.htmlModal(pluginConfig);
      this.show();
    }

    checkingSoftwareModal(callback: Function) {
      const checkSoftwareDiv = `<div class="progress">
                                    <div class="progress-bar progress-bar-info"></div>
                                <div>`;

      const checkSoftwareConfig = {
        titleclass: 'checkSoftware-tital',
        innerHtml: checkSoftwareDiv,
        progressbar: true,
      };

      this.htmlModal(checkSoftwareConfig);
      this.show();
      this.runProgressBar();
      setTimeout(() => {
        this.doCallback(callback);
      }, 3000);
    }

    acdWaitModal(isRickAstley, framesrc, callback: Function) {
      const acdwaitDiv = document.createElement('div');
      let titleclass = 'acdwait-title';
      acdwaitDiv.className = 'youtube-container';
      acdwaitDiv.id = 'acdWaitDiv';
      if (isRickAstley) {
        framesrc =
          'https://www.youtube.com/embed/dQw4w9WgXcQ?autoplay=1&rel=0&loop=1';
        titleclass = 'rickroll-title';
      }
      acdwaitDiv.innerHTML = `<div class="modal-header acd-wait-header">
                                        <h4 class="modal-title ${titleclass}"></h4>
                                        <button id="btnAcdAbandon" class="btn btn-danger btn-large">Cancel Call</button>
                                    </div>
                                    <iframe class="youtube" src=${framesrc} frameborder="0" allowfullscreen></iframe>`;

      const acdwaitConfig = {
        bodyElement: acdwaitDiv,
        fullmodal: true,
      };
      this.htmlModal(acdwaitConfig);
      this.show();
      const abandonButton = document.getElementById('btnAcdAbandon');
      abandonButton.addEventListener(
        'click',
        () => {
          this.close();
          Start.customerHasAbandoned = true;
        },
        false
      );
    }

    installModal(config: any, callback?: Function) {
      const conf = config || {};
      const installDiv = document.createElement('div');
      const installButtonDiv = document.createElement('div');
      const installBodyDiv = document.createElement('div');
      const ol = document.createElement('ol');
      let installButton: HTMLAnchorElement | HTMLButtonElement;
      let innerHtml = '';
      let footerButtons;

      if (conf.installButtonType === 'a') {
        installButton = document.createElement('a');
        installButton.href = conf.installButtonLink;
        installButton.className = 'btn btn-primary ' + conf.installButtonClass;
        if (conf.installButtonListener) {
          installButton.addEventListener(
            'click',
            conf.installButtonListener.bind(this)
          );
        }
      } else {
        installButton = document.createElement('button');
        installButton.onclick = conf.installButtonOnClick.bind(this);
        installButton.className = 'btn btn-primary ' + conf.installButtonClass;
      }

      if (conf.isChromeExtensionInstall) {
        for (let i = 0; i < 5; i++) {
          innerHtml =
            innerHtml +
            `<li class="chromeinstallextension-instructions-li${i + 1}"></li>`;
        }
      } else if (conf.innerHtml) {
        innerHtml = conf.innerHtml;
      } else {
        for (let i = 0; i < 3; i++) {
          innerHtml =
            innerHtml + `<li class="install-instructions-li${i + 1}"></li>`;
        }
      }

      installButtonDiv.className = 'install-button';
      installBodyDiv.className = 'install-instructions';
      ol.innerHTML = innerHtml;

      installButtonDiv.appendChild(installButton);
      installBodyDiv.appendChild(ol);
      installDiv.appendChild(installButtonDiv);
      installDiv.appendChild(installBodyDiv);

      const installModalConfig = <any>{
        titleclass: conf.titleclass,
        bodyElement: installDiv,
      };

      if (Array.isArray(conf.footerButtons)) {
        footerButtons = conf.footerButtons;
        installModalConfig.footerButtons = footerButtons;
      }

      this.htmlModal(installModalConfig);

      this.show();
      this.doCallback(callback);
    }

    vidyoConferenceModal(vidyoMain: VidyoMain, callback?: Function) {
      const vidyoConferenceDiv = document.createElement('div');
      const logo = this.makeCustomLogo();

      vidyoConferenceDiv.id = 'webRTCConferenceDiv';
      vidyoConferenceDiv.innerHTML =
        `<h4 id="videoStartMessage">Your video conference request has been received, your conference will begin in a moment.</h4>
                <div class="videoArea" id="VidyoArea" align="center">
                    <div class="videoWrapper" id="pluginHolder" align="center"></div>
                </div>
                <!--No self view with plugins, just using wrapper for logos-->
                <div class="footerDiv" id="footerArea" align="center">
                <div id="selfViewDiv" class="local-participant-wrapper">
                    ${logo}
                    ${logo}
                </div>` +
        this.makeConferenceFooter() +
        '</div>';

      const vidyoConferenceConfig = {
        bodyElement: vidyoConferenceDiv,
        fullmodal: true,
      };

      this.htmlModal(vidyoConferenceConfig);
      this.currentModal.style.display = 'none';

      this.show();
      const cameraButton = document.getElementById('camera_toggle');
      const micButton = document.getElementById('microphone_toggle');
      const speakerButton = document.getElementById('speaker_toggle');
      const disconnectButton = document.getElementById('disconnect_toggle');
      const shareSelect = document.getElementById('share_select');
      cameraButton.addEventListener(
        'click',
        vidyoMain.toggleConferenceButton.bind(vidyoMain)
      );
      micButton.addEventListener(
        'click',
        vidyoMain.toggleConferenceButton.bind(vidyoMain)
      );
      speakerButton.addEventListener(
        'click',
        vidyoMain.toggleConferenceButton.bind(vidyoMain)
      );
      shareSelect.addEventListener(
        'mouseenter',
        vidyoMain.updateShareList.bind(vidyoMain)
      );
      shareSelect.addEventListener(
        'change',
        vidyoMain.shareChanged.bind(vidyoMain)
      );
      disconnectButton.addEventListener(
        'click',
        vidyoMain.sendLeaveEvent.bind(vidyoMain)
      );
    }

    webRTCConferenceModal(vidyoMain: VidyoMain, callback?: Function) {
      const webRTCConferenceDiv = document.createElement('div');
      const logo = this.makeCustomLogo();

      webRTCConferenceDiv.id = 'webRTCConferenceDiv';
      webRTCConferenceDiv.innerHTML =
        `<h4 id="videoStartMessage">Your video conference request has been received, your conference will begin in a moment.</h4>
                <!--Begin Video Area-->
                <div class="videoArea" id="VidyoArea" align="center">

                    <!-- Shares container -->
                    <div id="shareVideoDiv" class="sharevideo-wrapper">
                        <div id="shareName" class="participant-title"></div>
                        <video id="shareVideo0" autoplay class="remotevideo-default"></video>
                    </div>

                    <!-- Particpants container -->
                    <div id="participants_box" class="participants-box">
                            <div id="participantDiv0" class="hide">
                                <div id="participant0" class="participant-title"></div>
                                <video id="remoteVideo0" autoplay class="remotevideo-default"></video>
                            </div>
                            <div id="participantDiv1" class="hide">
                                <div id="participant1" class="participant-title"></div>
                                <video id="remoteVideo1" autoplay class="remotevideo-default"></video>
                            </div>
                            <div id="participantDiv2" class="hide">
                                <div id="participant2" class="participant-title"></div>
                                <video id="remoteVideo2" autoplay class="remotevideo-default"></video>
                            </div>
                            <div id="participantDiv3" class="hide">
                                <div id="participant3" class="participant-title"></div>
                                <video id="remoteVideo3" autoplay class="remotevideo-default"></video>
                            </div>
                            <div id="participantDiv4" class="hide">
                                <div id="participant4" class="participant-title"></div>
                                <video id="remoteVideo4" autoplay class="remotevideo-default"></video>
                            </div>
                            <div id="participantDiv5" class="hide">
                                <div id="participant5" class="participant-title"></div>
                                <video id="remoteVideo5" autoplay class="remotevideo-default"></video>
                            </div>
                            <div id="participantDiv6" class="hide">
                                <div id="participant6" class="participant-title"></div>
                                <video id="remoteVideo6" autoplay class="remotevideo-default"></video>
                            </div>
                            <div id="participantDiv7" class="hide">
                                <div id="participant7" class="participant-title"></div>
                                <video id="remoteVideo7" autoplay class="remotevideo-default"></video>
                            </div>
                            <div id="participantDiv8" class="hide">
                                <div id="participant8" class="participant-title"></div>
                                <video id="remoteVideo8" autoplay class="remotevideo-default"></video>
                            </div>
                    </div>
                </div>
                <!--End Video Area-->
                <div class="footerDiv" id="footerArea" align="center">
                <div id="selfViewDiv" class="local-participant-wrapper">
                    ${logo}
                    <video id="localVideo" autoplay muted class="localvideo-default"></video>
                    ${logo}
                </div>` +
        this.makeConferenceFooter() +
        '</div>';

      const webRTCConferenceConfig = {
        bodyElement: webRTCConferenceDiv,
        fullmodal: true,
      };

      this.htmlModal(webRTCConferenceConfig);
      this.currentModal.style.display = 'none';

      this.show();
      const cameraButton = document.getElementById('camera_toggle');
      const micButton = document.getElementById('microphone_toggle');
      const speakerButton = document.getElementById('speaker_toggle');
      const disconnectButton = document.getElementById('disconnect_toggle');
      const shareButton = document.getElementById('share_toggle');
      cameraButton.addEventListener(
        'click',
        vidyoMain.toggleConferenceButton.bind(vidyoMain)
      );
      micButton.addEventListener(
        'click',
        vidyoMain.toggleConferenceButton.bind(vidyoMain)
      );
      speakerButton.addEventListener(
        'click',
        vidyoMain.toggleConferenceButton.bind(vidyoMain)
      );
      shareButton.addEventListener(
        'click',
        vidyoMain.toggleConferenceButton.bind(vidyoMain)
      );
      disconnectButton.addEventListener(
        'click',
        vidyoMain.sendLeaveEvent.bind(vidyoMain)
      );
    }

    makeConferenceFooter() {
      let shareElement;
      if (
        this.UseWebRTC &&
        this.isWebRTCCapable &&
        this.vidyoDetection.isWebRTCAvailable
      ) {
        shareElement = `<div class="webRTCconference-button">
                                    <input class="tgl-cb" id="share_toggle" type="checkbox"/>
                                    <label class="tgl-btn" id="lbl_share_toggle" for="share_toggle">Screen Share OFF</label>
                                </div>`;
      } else {
        shareElement = `<div class="webRTCconference-button">
                                    <select id="share_select" title="Share" title="Share/Unshare App">
                                        <option value="-1">Select an App or Desktop to Share</option>
                                    </select>
                                </div>`;
      }
      const conferenceFooter = `<div id="webRTCConferenceFooter">
                    <div id="webRTCConferenceButtons">
                        ${shareElement}
                        <div class="webRTCconference-button">
                            <input class="tgl-cb" id="microphone_toggle" type="checkbox" checked />
                            <label class="tgl-btn" id="lbl_microphone_toggle" for="microphone_toggle">Microphone ON</label>
                        </div>
                        <div class="webRTCconference-button">
                            <input class="tgl-cb" id="camera_toggle" type="checkbox" checked />
                            <label class="tgl-btn" id="lbl_camera_toggle" for="camera_toggle">Camera ON</label>
                        </div>
                        <div class="webRTCconference-button">
                            <input class="tgl-cb" id="speaker_toggle" type="checkbox" checked />
                            <label class="tgl-btn" id="lbl_speaker_toggle" for="speaker_toggle">Speaker ON</label>
                        </div>
                        <div class="webRTCconference-button">
                            <input class="tgl-cb" id="disconnect_toggle" type="checkbox" />
                            <label class="tgl-btn tgl-danger" id="lbl_disconnect_toggle" for="disconnect_toggle">End Call</label>
                        </div>
                    </div>
                </div>`;

      return conferenceFooter;
    }

    makeCustomLogo() {
      let logo;
      let logoDisplay = '';
      let logosrc;
      if (this.CustomerLogo === null) {
        logoDisplay = `display="none"`;
        logosrc = '';
      } else {
        logosrc = this.ImagePath + this.CustomerLogo;
      }

      logo = `<div id="webRTCCustomerLogoLeft" class="webRTCCustomerLogo" ><img src="${logosrc}" ${logoDisplay}></div>`;
      return logo;
    }

    mobileLaunchModal(vidyoMobileUrl: string, mobileOS: string) {
      console.log('Launching mobile modal for OS: ' + mobileOS);
      const mobileLaunchDiv = document.createElement('div');
      const joinButtonTextDiv = document.createElement('div');
      const joinButtonDiv = document.createElement('div');
      const joinButton = document.createElement('button');
      const installButtonDiv = document.createElement('div');
      const installButtonTextDiv = document.createElement('div');
      const installButtonTextNode = document.createTextNode('For iOS');
      const installOSXButtonTextNode = document.createTextNode('For OSX');
      const installButton = document.createElement('button');
      const installOSXButtonDiv = document.createElement('div');
      const installOSXButtonTextDiv = document.createElement('div');
      const installOSXButton = document.createElement('button');
      let installUrl: string;
      let installOSXUrl: string;

      if (this.MobileClient.toLowerCase() === 'vidyoconnect') {
        joinButtonTextDiv.id = 'vidyoConnectjoinButtonTextDiv';
        installButtonTextDiv.id = 'vidyoConnectinstallButtonTextDiv';
        installOSXButtonTextDiv.id = 'vidyoConnectinstallOSXButtonTextDiv';
      } else {
        joinButtonTextDiv.id = 'vidyoMobilejoinButtonTextDiv';
        installButtonTextDiv.id = 'vidyoMobileinstallButtonTextDiv';
      }

      mobileLaunchDiv.id = 'mobileLaunchDiv';
      joinButtonDiv.id = 'mobilejoinButtonDiv';
      joinButton.id = 'mobilejoinButton';
      joinButton.className =
        'btn btn-primary btn-lg center-block mobilejoinButton';

      installButtonDiv.id = 'mobileinstallButtonDiv';
      if (mobileOS === 'Android') {
        installButton.id = 'androidInstallButton';
        installButton.style.backgroundImage =
          "url('" + this.ImagePath + "android_download.png')";
        installUrl = this.AndroidInstallLink;
      }
      if (mobileOS === 'iOS') {
        installButton.id = 'iOSInstallButton';
        installButton.style.backgroundImage =
          "url('" + this.ImagePath + "ios_download.svg')";
        installUrl = this.IOSInstallLink;
      }
      if (mobileOS === 'OS X') {
        /* When a browser is running in Desktop mode on a mobile device,
        we can't tell. So if we see OS X, the browser may be running on either
        desktop or mobile. Therefore, show install buttons for iOS and OSX, and
        let the user select the correct install for the OS they are actually
        running on. */
        installButtonDiv.id = 'iOSInstallButtonDiv';
        installButton.id = 'iOSInstallButton';
        installButton.style.backgroundImage =
          "url('" + this.ImagePath + "ios_download.svg')";
        installUrl = this.IOSInstallLink;
        installOSXButtonDiv.id = 'OSXInstallButtonDiv';
        installOSXButton.id = 'OSXInstallButton';
        installOSXButton.style.backgroundImage =
          "url('" + this.ImagePath + "cloud_download-24px.svg')";
        installOSXUrl =
          this.config.InstallersPath + 'VidyoConnectInstaller-macosx.dmg';
      }
      installButton.className = 'btn btn-primary center-block';
      installOSXButton.className = 'btn btn-primary center-block';

      joinButton.addEventListener('click', () => {
        // window.open(vidyoMobileUrl);
        this.closeMobile();
        window.location.href = vidyoMobileUrl;
      });
      installButton.addEventListener('click', () => {
        // window.open(installUrl);
        window.location.href = installUrl;
      });
      installOSXButton.addEventListener('click', () => {
        // window.open(installUrl);
        window.location.href = installOSXUrl;
      });

      const cancelButton = document.createElement('button');
      cancelButton.className = 'btn btn-danger cancelButton';
      cancelButton.addEventListener(
        'click',
        () => {
          this.closeMobile();
        },
        false
      );

      const footerButtons = [cancelButton];

      if (mobileOS === 'iOS' || mobileOS === 'Android' || mobileOS === 'OS X') {
        joinButtonDiv.appendChild(joinButton);
        if (mobileOS === 'iOS' || mobileOS === 'OS X') {
          installButtonDiv.appendChild(installButtonTextNode);
        }
        installButtonDiv.appendChild(installButton);
        mobileLaunchDiv.appendChild(joinButtonTextDiv);
        mobileLaunchDiv.appendChild(joinButtonDiv);
        mobileLaunchDiv.appendChild(installButtonTextDiv);
        mobileLaunchDiv.appendChild(installButtonDiv);
        if (mobileOS === 'OS X') {
          installOSXButtonDiv.appendChild(installOSXButtonTextNode);
          installOSXButtonDiv.appendChild(installOSXButton);
          mobileLaunchDiv.appendChild(installOSXButtonTextDiv);
          mobileLaunchDiv.appendChild(installOSXButtonDiv);
        }
      } else {
        // Should never get here, as we detect whether we support their device prior to this
        // However, should have fallback just in case we get here somehow when we shouldn't
        // Give them a button to click to close out the modal(s)
        // TODO: Provide a button to invoke a tel://, so they can place a regular call
        mobileLaunchDiv.innerHTML = `<div id="mobileLaunchDivError">
                                            We're sorry, but we currently don't support your device for video.
                                            /* <button class="btn-danger onclick="${this.close()}">OK, return me to website</button> */
                                        <div>`;
      }

      const mobileLaunchConfig = {
        titleclass: 'mobilelaunch-title',
        bodyElement: mobileLaunchDiv,
        fullmodal: false,
        hasCloseButton: false,
        footerButtons: footerButtons,
      };

      this.htmlModal(mobileLaunchConfig);
      this.show();
    }

    cameraNotReadyModal(callbackForCancel?: Function) {
      const cameraNotReadyDiv = document.createElement('div');
      cameraNotReadyDiv.id = 'cameraNotReadyDiv';
      const cancelButton = document.createElement('button');
      cancelButton.className = 'btn btn-danger cancelButton';
      cancelButton.addEventListener(
        'click',
        () => {
          this.close();
          if (callbackForCancel) {
            this.doCallback(callbackForCancel);
          }
        },
        false
      );

      const footerButtons = [cancelButton];

      const cameraNotReadyConfig = {
        titleclass: 'cameraNotReady-title',
        bodyElement: cameraNotReadyDiv,
        hasCloseButton: false,
        footerButtons: footerButtons,
      };

      this.htmlModal(cameraNotReadyConfig);
      this.show();
    }

    show() {
      // insert modal in web page body
      document.body.appendChild(this.currentModal);
      // Mobile modals are positioned in upper-left corner
      // Automatically scroll to top-left, so that modal is visible on all devices
      window.scrollTo(0, 0);
    }

    close() {
      if (this.currentModal) {
        document.body.removeChild(this.currentModal);
        this.currentModal = undefined;
      }
    }

    closeMobile() {
      if (this.currentModal) {
        document.body.removeChild(this.currentModal);
        this.currentModal = undefined;
      }
      const modals = document.getElementsByTagName('adapt-modal');
      for (let index = 0; index < modals.length; index++) {
        const modal = modals[index];
        document.body.removeChild(modal);
      }
      const fullmodals = document.getElementsByTagName('adapt-fullmodal');
      for (let index = 0; index < fullmodals.length; index++) {
        const fullmodal = fullmodals[index];
        document.body.removeChild(fullmodal);
      }
    }

    elementEnableDisable(element: any) {
      if (element.disabled) {
        element.disabled = !element.disabled;
      }
    }

    runProgressBar() {
      const progressBar = <HTMLElement>(
        this.currentModal.getElementsByClassName('progress-bar')[0]
      );
      let width = 1;
      const id = setInterval(frame, 10);

      function frame() {
        if (width >= 100) {
          clearInterval(id);
        } else {
          width++;
          progressBar.style.width = width + '%';
        }
      }
    }
  }
}
